<template>
  <form class="form loginForm" @submit.prevent="onSubmit()">
    <div class="form__create-acc" v-if="createAccInfo">
      <ul v-if="typeof createAccText === 'object' && createAccText.length > 1">
        <li
          v-for="item in createAccText"
          :key="item"
          v-html="item"
        />
      </ul>
      <div v-else-if="typeof createAccText === 'object'" v-html="createAccText[0]"></div>
      <div v-else v-html="createAccText"></div>
    </div>
    <template v-else-if="hasThirdPartySSO">
      <div class="form__row form--links">
        <div class="form__get-account">
          <a href="" @click.prevent="$emit('showCreateAcc')">{{ $t('login.get_account_text') }}</a>
        </div>
        <div class="form__forgot-password">
          <a
            :href="forgetPasswordRedirect"
            @click="onForgetPasswordClick"
          >{{ $t('login.forgot_password.text') }}</a>
        </div>
      </div>
      <a
        :href="configUrlSSO"
        class="form__button"
        :style="{'--custom-button-bg': customButtonBg}"
      >
        <span>{{ $t('login.enter') }}</span>
      </a>
    </template>
    <template v-else-if="!hasThirdPartySSO">
      <fieldset v-if="tab==='login'">
        <div class="form__row">
          <div class="el-input">
            <input class="el-input__inner"
                  type="text"
                  name="auth"
                  :placeholder="loginInputLabel"
                  v-model="auth"
                  v-validate.disable="'required'"
                  v-on:input="clearErrors()"
                  tabindex="1"
                  ref='firstInput'
            >

          </div>
          <label class="form__label">{{ loginInputLabel }}</label>
        </div>
        <div class="form__row">
          <div class="el-input">
            <input class="el-input__inner"
                  :type="!showPassword ? 'password' : 'text'"
                  name="password"
                  v-model="password"
                  :placeholder="$t('login.password_input.placeholder')"
                  v-validate.disable="'required'"
                  tabindex="2"
                  v-on:input="clearErrors()"
            >
            <span class="el-input__suffix" @click="showPassword = !showPassword">
              <span class="el-input__suffix-inner">
                <i v-if="!showPassword"
                class="el-input__icon fa fa-eye-slash"
                aria-hidden="true"
                :title="$t('login.password_input.show_hint')"></i>
              <i v-else
                class="el-input__icon fa fa-eye"
                aria-hidden="true"
                :title="$t('login.password_input.hide_hint')"></i>
              </span>
            </span>
          </div>
          <label class="form__label">{{ $t('login.password_input.label') }} </label>
        </div>
        <div class="form__row form--links">
          <div class="form__get-account">
            <a href="/" @click.prevent="$emit('showCreateAcc')">{{ $t('login.get_account_text') }}</a>
          </div>
          <div class="form__forgot-password">
            <a
              :href="forgetPasswordRedirect"
              @click="onForgetPasswordClick"
            >{{ $t('login.forgot_password.text') }}</a>
          </div>
        </div>
        <button
          class="form__button form__button--entery"
          :style="{'--custom-button-bg': customButtonBg}"
          tabindex="3"
        >
          <span>{{ $t('login.enter') }}</span>
        </button>
        <div v-if="showCancel" @click.prevent="$emit('login-canceled')" class="form_button">{{ $t('labels.cancel') }}</div>
      </fieldset>
      <fieldset v-if="tab==='forgotPassword'">
        <div class="form__row">
          <div class="el-input">
            <input class="el-input__inner"
                  type="text"
                  name="auth"
                  :placeholder="$t('login.forgot_password.placeholder')"
                  v-model="auth"
                  v-validate.disable="'required'"
                  v-on:input="clearErrors()"
                  tabindex="1"
                  ref='firstInput'
            >
          </div>
          <label class="form__label">{{ $t('login.forgot_password.label') }}</label>
        </div>
        <button
          class="form__button"
          tabindex="3"
          @click.prevent="sendCode"
        >
          {{ $t('login.password_recover.button_text') }}
        </button>
        <div class="cancelForgot" tabindex="4" @click.prevent="showLogin"><a @click.prevent href="#">{{ $t('labels.cancel') }}</a></div>
      </fieldset>
      <fieldset v-if="tab==='enterCode'">
        <div class="form__row">
          <div class="el-input">
            <input class="el-input__inner"
                  type="text"
                  name="code"
                  :placeholder="$t('login.password_recover.placeholder')"
                  v-model="code"
                  v-validate.disable="'required'"
                  v-on:input="clearErrors()"
                  tabindex="1"
                  ref='firstInput'
            >
          </div>
          <label class="form__label">{{ $t('login.password_recover.label') }}</label>
        </div>
        <button
          class="form__button"
          tabindex="3"
          @click.prevent="checkCode"
        >
          {{ $t('login.password_recover.send_text') }}
        </button>
        <div class="cancelForgot" tabindex="4" @click.prevent="showLogin"><a @click.prevent href="#">{{ $t('labels.cancel') }}</a></div>
      </fieldset>
      <fieldset v-if="tab==='setPassword'">
        <div class="form__row">
          <div class="el-input">
            <password
              v-model="newPassword"
              :toggle="true"
              :placeholder="$t('login.new_password.placeholder')"
              v-validate.disable="'required'"
              v-on:input="clearErrors()"
              @passwordGenerated="onPasswordGenerated"
            ></password>
          </div>
          <label class="form__label">{{ $t('login.new_password.label') }}</label>
        </div>
        <div class="form__row">
          <div class="el-input">
            <input class="el-input__inner"
                  type="password"
                  name="password"
                  v-model="newPasswordRepeat"
                  :placeholder="$t('login.new_password.repeat.placeholder')"
                  v-validate.disable="'required'"
                  tabindex="2"
                  v-on:input="clearErrors()"
            >
          </div>
          <label class="form__label">{{ $t('login.new_password.repeat.label') }}</label>
        </div>
        <button
          class="form__button"
          tabindex="3"
          @click.prevent="setPassword"
        >
          {{ $t('login.new_password.repeat.button_text') }}
        </button>
        <div class="cancelForgot" tabindex="4" @click.prevent="showLogin"><a @click.prevent href="#">{{ $t('labels.cancel') }}</a></div>
      </fieldset>
    </template>
  </form>
</template>

<script>
  import auth from 'src/services/auth'
  import localStorageTransport from 'src/services/localStorageTransport'
  import Password from './PasswordInput'
  import {
    E_PASSWORD,
    E_STATUS,
    E_LOGIN,
    CONF_FORGET_PASSWORD_REDIRECT,
    CONF_LOGIN_INPUT_LABEL,
    CONF_THIRD_PARTY_SSO,
    CONF_URL_SSO,
    CUSTOM_LOGIN_PAGE
  } from '@/constants'
  import config from '@/config'
  import Cookies from 'js-cookie'

  export default {
    name: 'Authenticate',
    components: {Password},
    data () {
      return {
        auth: '',
        password: '',
        tab: 'login',
        code: '',
        newPassword: '',
        newPasswordRepeat: '',
        showPassword: false,
        forgetPasswordRedirect: config(CONF_FORGET_PASSWORD_REDIRECT) || ''
      }
    },
    props: [
      'showCancel',
      'createAccInfo',
      'createAccText'
    ],
    computed: {
      customLoginPage () {
        return config(CUSTOM_LOGIN_PAGE);
      },
      customButtonBg () {
        if (this.customLoginPage && this.customLoginPage.FORM_BUTTON_BACKGROUND) {
          return this.customLoginPage.FORM_BUTTON_BACKGROUND;
        }

        return null;
      },
      hasThirdPartySSO () {
        return config(CONF_THIRD_PARTY_SSO) === true && this.configUrlSSO;
      },
      configUrlSSO () {
        return config(CONF_URL_SSO);
      },
      loginInputLabel () {
        const langUpper = this.$store.state.lang.toUpperCase();
        const configLoginInputLabel = config(CONF_LOGIN_INPUT_LABEL);

        if (configLoginInputLabel) {
          return configLoginInputLabel[langUpper] ? configLoginInputLabel[langUpper] : configLoginInputLabel.EN
        }

        return this.$t('login.login_input.placeholder')
      }
    },
    methods: {
      onForgetPasswordClick (e) {
        if (!this.forgetPasswordRedirect) {
          this.$emit('showForgotPassword');
          e.preventDefault();
        }
      },
      isAuthPhone () {
        let phoneReg = /^[+0-9-()\s]{10,}$/;
        let normilizeNumber = this.normalizePhone(this.auth);

        if (phoneReg.test(this.auth)) {
          if (this.auth.charAt(0) === '+') {
            return '+' + normilizeNumber;
          } else if (normilizeNumber.length >= 10) {
            if (normilizeNumber.charAt(0) === '7') {
              return '+' + normilizeNumber;
            } else if (normilizeNumber.charAt(0) === '8') {
              return '+7' + normilizeNumber.substring(1);
            } else {
              return '+7' + normilizeNumber;
            }
          } else {
            return this.auth;
          }
        } else {
          return this.auth
        }
      },
      normalizePhone (number) {
        return number.replace(/[^0-9\(\)\-]/gim, '')
      },
      onPasswordGenerated (newPass) {
        this.newPassword = newPass
        this.newPasswordRepeat = newPass
      },
      async setPassword () {
        /* try {
          this.$emit('hideError')
          if (!this.code || this.code.length !== 6) {
            this.$emit('getError', 'Проверьте правильность ввода кода восстановления')
          } else if (!this.newPassword) {
            this.$emit('getError', 'Введите новый пароль')
          } else if (this.newPassword !== this.newPasswordRepeat) {
            this.$emit('getError', 'Пароли не совпадают')
          } else {
            await this.$store.dispatch('users/setPasswordByCode', {
              code: this.code,
              password: this.newPassword,
              email: this.auth
            })
            this.tab = 'login'
            this.code = ''
            this.newPassword = ''
            this.newPasswordRepeat = ''
            this.$emit('passwordChanged')
          }
        } catch (e) {
          if (e.response && e.response.data && e.response.data.error.code === 'E_FAILED') {
            this.$emit('getError', 'Введенный код неверен или просрочен')
          } else {
            this.$emit('getError', 'Произошла неизвестная ошибка, попробуйте позже')
          }
        } */
      },
      async checkCode () {
        /*try {
          this.$emit('hideError')
          if (!this.code || this.code.length !== 6) {
            this.$emit('getError', 'Проверьте правильность ввода кода восстановления')
          } else {
            await this.$store.dispatch('users/setPasswordByCode', {
              code: this.code,
              email: this.auth
            })
            this.tab = 'setPassword'
            this.newPassword = ''
            this.newPasswordRepeat = ''
          }
        } catch (e) {
          if (e.response && e.response.data && e.response.data.error.code === 'E_FAILED') {
            this.$emit('getError', 'Введенный код неверен или просрочен')
          } else {
            this.$emit('getError', 'Произошла неизвестная ошибка, попробуйте позже')
          }
        } */
      },
      async sendCode () {
        /* try {
          await this.$store.dispatch('users/sendResetPasswordCode', this.auth)
          this.tab = 'enterCode'
          this.$emit('hideError')
          this.code = ''
          this.newPassword = ''
          this.newPasswordRepeat = ''
          this.$emit('recoveryCodeSended')
        } catch (e) {
          if (e.response && e.response.data && e.response.data.error.code === 'E_PARAM') {
            this.$emit('getError', 'Проверьте правильность ввода email')
          } else if (e.response && e.response.data && e.response.data.error.code === 'E_NOT_FOUND') {
            this.$emit('getError', 'Пользователь с таким email не найден')
          } else if (e.response && e.response.data && e.response.data.error.code === 'E_TOO_MANY_REQUESTS') {
            this.$emit('getError', 'Слишком часто, подождите немного перед повторной отправкой кода')
          } else {
            this.$emit('getError', 'Произошла неизвестная ошибка, попробуйте позже')
          }
        } */
      },
      showForgotPassword () {
        this.tab = 'forgotPassword'
        this.$emit('hideError')
      },
      showLogin () {
        this.tab = 'login'
        this.password = ''
        this.$emit('hideError')
      },
      onSubmit () {
        this.$validator.validate().then(result => {
          if (result) {
            this.login()
          } else {
            this.getError()
          }
        })
      },
      getError () {
        this.$emit('getError', this.errors.items[0].msg)
      },
      clearErrors () {
        this.$validator.reset();
        this.$emit('hideError')
      },
      async login () {
        let login = this.isAuthPhone();

        if (typeof login === 'string') {
          login = login.toLowerCase();
        }

        const authData = {login, password: this.password}
        const langChecked = Cookies.get('lang_checked');

        if (langChecked) {
          authData.lang = langChecked;
        }

        try {
          let pathTo = await this.$store.dispatch('user/login', authData)
          this.$notify({
            // @ts-ignore
            title: this.$t('login.auth.success_login.title'),
            // @ts-ignore
            message: this.$t('login.auth.success_login.message'),
            type: 'success',
            offset: 75,
            duration: 2000
          })
          localStorageTransport.emit('login', true)
          localStorageTransport.emit('keepalive', (new Date()).getTime())
          sessionStorage.setItem('redirectPage', pathTo);
          this.$emit('login-success', pathTo)
        } catch (e) {
          console.log('LOG: login -> e', e)
          let message = this.$t('login.auth.unknown');
          if (e.getCode() === E_STATUS || e.getCode() === E_PASSWORD || e.getCode() === E_LOGIN) {
            message = this.$t('login.auth.error_login.message');
          }
          this.$notify({
            // @ts-ignore
            title: this.$t('login.auth.error_login.title'),
            message,
            type: 'error',
            offset: 75,
            duration: 2000
          })
          this.$emit('login-error')
        }
      },
      setFocus () {
        if (this.$refs.firstInput) {
          this.$refs.firstInput.focus()
        }
      }
    },
    created () {
      if (this.$route.params.tab === 'enterCode' && this.$route.params.email) {
        this.tab = 'enterCode'
        this.auth = this.$route.params.email
      }
      if (this.$route.params.code) {
        this.code = this.$route.params.code
      }
      const required = this.$t('login.validator.required');
      const email = this.$t('login.validator.email');
      this.$validator.localize('ru', {
        messages: {
          required: function () {
            return required
          },
          email: function () {
            return email
          }
        }
      });
    },
    mounted () {
      this.setFocus()
      if (this.$route.params.code) {
        this.checkCode()
      }
    }
  }
</script>

<style lang="scss">
@import 'src/assets/sass/core';

  .form__create-acc {
    font-size: 16px;
    color: #909399;

    ul {
      padding-left: 20px;

      li + li {
        margin-top: 15px;
      }
    }

    a {
      color: #ff5d2b;
      text-decoration: underline;

      &:hover {
        color: #ff5d2b;
        text-decoration: none;
      }
    }
  }
  .loginForm {
    .form--links {
      text-align: center;
      margin-top: -4px;
      flex-direction: column;
      padding-bottom: 27px;

      @include respond-to(phone-s, min) {
        flex-direction: row;
        justify-content: space-between;
        .form__get-account {
          margin-bottom: 0;
        }
      }
      .form__get-account {
        margin-bottom: 13px;
        padding-top: 0;
      }
    }
    .el-input__inner:hover {
      border-color: rgba(146, 145, 153, 1);
    }
    .el-input.is-active .el-input__inner, .el-input__inner:focus {
      border-color: #ff3948;
    }
    .form__forgot-password, .form__get-account {
      a {
        text-decoration: underline;
        border: none;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .cancelForgot {
      margin-top: 15px;
      color: #ACACAC;
      display: block;
      text-align: center;
      cursor: pointer;
      a {
        border-bottom: 1px solid #ACACAC;
      }
    }
    .Password {
      &__badge {
        box-sizing: content-box;
        width: auto;
      }
      &__strength-meter {
        margin-bottom: 5px;
      }
    }
    .form {
      &__button {
        text-align: center;
        border-radius: 9px;
        background: var(--custom-button-bg, linear-gradient(89.46deg, #FF3948 -44.58%, #FFAD37 158.4%));
        font-size: 14px;
        font-weight: normal;
        padding-bottom: 13px;
        &:hover {
          box-shadow: 0px 2px 15px -3px var(--custom-button-bg, rgb(255, 112, 65)), inset 0px 2px 15px 3px rgba(255, 255, 255, 0.0);
          color: #fff;
        }
        &:active {
          box-shadow: 0px 2px 15px -3px rgba(255, 255, 255, .0), inset 0px 2px 15px 3px rgba(255, 255, 255, 0.2);
        }
        &--entery {
          margin-top: 1px;
        }

        span {
          color: #fff;
        }
      }
    }
  }
</style>